import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { UserState } from './types'
import { USER_ACTIONS, USER_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
import locationModule from '@/store/location'
import { NAMESPACES } from '../types'

const user: Module<UserState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    [NAMESPACES.LOCATION]: locationModule
  }
}

export { USER_ACTIONS, USER_GETTERS }
export type { UserState }
export default user
